export const menusList = [
    {
        name: '总览页',
        path: '/homePage',
        icon: 'user'
    },
    {
        name: '谱系',
        path: '/pedigree',
        icon: 'setting'
    },
    {
        name: '谱文',
        path: '/spectrums',
        icon: 'shop'
    },
    {
        name: '谱书',
        path: '/books',
        icon: 'tickets'
    },
    {
        name: 'OCR',
        path: '/articles',
        icon: 'pie-chart'
    },
    {
        name: '管理',
        path: '/rights',
        icon: 'user'
    }
]
